import { stats, testimonials } from "@/mocks/chigua";

const values = [
  { icon: "ri-focus-3-line", title: "只跟真进展", desc: "楼层只收录有出处、可核对的进展，不靠标题党凑热度。" },
  { icon: "ri-archive-drawer-line", title: "信息分层", desc: "用「首发 / 楼中锤 / 官方信号」标注来源层级，一眼分清锤和猜。" },
  { icon: "ri-time-line", title: "更新不掉线", desc: "正在蹲的瓜有新进展就顶上来，持续吃瓜不遗漏。" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">ABOUT 吃瓜吧</span>
            <h2 className="mt-1 text-2xl text-foreground-950 md:text-4xl">把散落的瓜，变成能蹲的楼</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              热搜刷十条只有一条能对上号，评论区翻到底也等不到后续。吃瓜吧把这些分散的碎片，按事件聚成一条条「正在蹲的瓜」，
              用楼层跟进新进展，让盖楼蹲帖的楼友随时知道瓜走到哪一步，更新随时顶上来。
            </p>
            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-background-200/70 bg-background-50 px-3 py-5 text-center">
                  <p className="font-heading text-2xl text-primary-600">{s.value}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-center gap-3">
            {values.map((v) => (
              <div
                key={v.title}
                className="flex items-start gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-800">
                  <i className={`${v.icon} text-xl leading-none`} />
                </span>
                <div>
                  <h3 className="text-base font-medium text-foreground-900">{v.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <div className="flex items-end justify-between">
            <h3 className="text-xl text-foreground-950 md:text-2xl">楼友怎么说</h3>
            <span className="text-xs text-foreground-500">来自瓜田评论区 · 节选</span>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5">
                <div className="flex items-center gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm leading-none" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-4 text-xs font-medium text-foreground-500">{t.name}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}